'use client';

import AddressForm from 'components/exploits/AddressForm';
import ExploitChecker from 'components/exploits/ExploitChecker';
import { AddressPageContextProvider } from 'lib/hooks/page-context/AddressPageContext';
import { type Exploit, getUniqueChainIds } from 'lib/utils/exploits';
import { Suspense, useMemo, useState } from 'react';
import type { Address } from 'viem';

interface Props {
  exploit: Exploit;
}

const ExploitCheckerWrapper = ({ exploit }: Props) => {
  const [address, setAddress] = useState<Address | undefined>();
  const chainIds = useMemo(() => getUniqueChainIds(exploit), [exploit]);

  return (
    <Suspense>
      <AddressPageContextProvider address={address!} initialChainId={chainIds[0]}>
        <AddressForm onSubmit={setAddress} chainIds={chainIds} />
        <ExploitChecker exploit={exploit} />
      </AddressPageContextProvider>
    </Suspense>
  );
};

export default ExploitCheckerWrapper;
